import { IAdjudicationWFState } from '../types/workflow-phases';

export const adjudicationStatusByReviewRound = {
  firstReviewRound: [
    'invited',
    'assessment',
    'interrupted',
    'reviewed',
    'declined',
    'expired',
    'rescinded',
    'firstAssessment',
    'submittedFirstAssessment'
  ],
  revisionReviewRound: [
    'awaitingRevision',
    'awaitingRevisionReviewRequest',
    'revisionAssessment',
    'submittedRevisionAssessment',
    'revisionInvited'
  ]
};

/**
 * Active = Requires attention.
 * Inactive = Does not require attention.
 */
const activeVsInactiveAdjudicationStatus: Record<
  IAdjudicationWFState,
  'active' | 'inactive'
> = {
  submittedFirstAssessment: 'inactive',
  awaitingRevision: 'inactive',
  awaitingRevisionReviewRequest: 'inactive',
  submittedRevisionAssessment: 'inactive',
  removed: 'inactive',
  reviewed: 'inactive',
  declined: 'inactive',
  expired: 'inactive',
  invited: 'active',
  firstAssessment: 'active',
  rescinded: 'active',
  revisionAssessment: 'active',
  revisionInvited: 'active',
  interrupted: 'inactive',
  assessment: 'active',
  initial: 'active',
  closed: 'inactive'
};

export const inactiveAdjudicationStatuses: IAdjudicationWFState[] =
  Object.entries(activeVsInactiveAdjudicationStatus)
    .filter(([_, value]) => value === 'inactive')
    .map(([key, _]) => key);

export const ADJUDICATOR_INVITE_ERROR_MESSAGES = {
  AUTHOR:
    'This person is listed as an author of this submission and cannot be invited as an Adjudicator.',
  REVIEWER:
    'This person is already a reviewer for this submission and cannot be invited as an Adjudicator.',
  ADJUDICATOR: 'This Adjudicator is already associated with this Submission.',
  OPPOSED_REVIEWER:
    'The submitting author has opposed this person as a reviewer. You can still invite them, but please evaluate their feedback carefully.'
};
